import { detect } from "detect-browser";
import {APP_VENDOR, APP_VERSION, DEBUG } from "./Constants";
import { getMonth } from "View/helper";
import { isIOS } from "react-device-detect";
import * as jose from 'jose'
import * as Sentry from "@sentry/react";
import { osVersion } from 'react-device-detect';

export function consoleLog() {
    if(DEBUG === "true" || DEBUG === true) {
        console.log.apply(console, arguments);
    }
}
export function getUrlVars() {
    let vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
export function cacheUtility(action, key, data=undefined) {
    switch (action) {
        case "get":
            if(localStorage.getItem(key))
                return atob(localStorage.getItem(key));
            return null;
        case "set":
            if(data)
                localStorage.setItem(key, btoa(data));
            else
                localStorage.removeItem(key);
            return true;
        default:
            return null;
    }
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this, args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}


export function throttle(func, wait) {
    let functionCall = true;
    return function() {
        if (functionCall) {
            func();
            functionCall = false;
            setTimeout(() => {
                functionCall = true;
            },wait);
        }
    }
}


export function roundTo2(amount) {
    return Number.isInteger(amount) ? parseInt(amount, 10) : amount.toFixed(2);
}


export function Comma(v) {
    let neg = v >= 0 ? "" : "-";
    let x = v.toString().replace(/-/,"");
    let afterPoint = '';
    if(x.indexOf('.') > 0)
        afterPoint = x.substring(x.indexOf('.'),x.length);
    x = Math.floor(parseFloat(x));
    x = x.toString();
    let lastThree = x.substring(x.length-3);
    let otherNumbers = x.substring(0,x.length-3);
    if(otherNumbers !== '')
        lastThree = ',' + lastThree;
    return neg + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
}


export function openFullscreen() {
    let elem = document.getElementsByClassName("outerWrapper")[0];
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
}


export function timeDiff(dateObj1, dateObj2) {
    let diffMs = (dateObj2 - dateObj1); // milliseconds between dateObj1 & dateObj2
    if (diffMs < 0)
        return { days: 0, hrs: 0, mins: 0, secs: 0};
    let days = Math.floor(diffMs / 86400000); // days
    let hrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    let mins = Math.floor(((diffMs % 86400000) % 3600000) / 60000); // minutes
    let secs = Math.round((((diffMs % 86400000) % 3600000) % 60000) / 1000); // seconds
    if(secs === 60) {
        mins += 1;
        secs = 0;
    }
    return  { days, hrs, mins, secs };
}

export function formatDate(date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

export function getTime(timestamp) {
    let date = new Date(timestamp);
    let hours = date.getHours();
    hours = hours > 9 ? hours : "0"+hours;
    let mins = date.getMinutes();
    mins = mins > 9 ? mins : "0"+mins;
    return hours+":"+mins;
}


export function copyToClipboard(containerid) {
    if (document.selection) {
        let range = document.body.createTextRange();
        range.moveToElementText(document.getElementById(containerid));
        range.select().removeAllRanges();
        range.select().createTextRange();
        document.execCommand("copy");
        alert("Copied - " + document.getElementById(containerid).innerHTML)

    } else if (window.getSelection) {
        let range = document.createRange();
        range.selectNode(document.getElementById(containerid));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        alert("Copied - " + document.getElementById(containerid).innerHTML)
    }
}

export function callCleverTapEvent(eventName,payload) {
    if (window.clevertap) {
        try {
            payload["browser_name"] = detect().name.includes("edge") ? "Edge" : detect().name;
            if (!(window.location.href.includes("view=ios"))) {
                payload["browser_version"] = parseInt(detect().version);
                payload["platform"] = "Web"
            }
            payload["language"] = navigator.language.substring( 0, 2 );
            payload["os"] = navigator.platform;
            window.clevertap.event.push(eventName, payload);
            if (window.Hansel) {
                window.Hansel.logEvent(eventName, "ctp", payload);
            }
            consoleLog(eventName, payload)
        } catch(err) {
            consoleLog(err);
        }
    }
}

export function getPlatformData() {
    try {
        let data = {"pf" : detect().name, "av": APP_VERSION, "tp": detect().type, "os": detect().os, "ov": osVersion }
        const res = btoa(JSON.stringify(data));
        return res;
    }
    catch {
        return btoa("{}");
    }
}

export function formetIndianRupee(num){
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}


export function returnMoneyConvert(val) {
    if (val >=1000 && val < 100000) {
        return `${val/1000}K`;
    }
    if (val >= 100000 && val < 10000000) {
        return `${val/100000} L`;
    }
    if(val >=10000000){
        return `${val/10000000} Cr`
    }
    return val;
}

export function numberFormatter(val) {
    val = parseInt(val);
    if (val <= 999)
        return val;
    if (val <= 99999) {
        let numerator = parseInt(val / 1000, 10);
        let remainder = parseInt((val % 1000) / 100, 10);
        return numerator + (remainder > 0 ? "." + remainder : "") + "K";
    }
    if (val <= 9999999) {
        let numerator = parseInt(val / 100000, 10);
        let remainder = parseInt((val % 100000) / 10000, 10);
        return numerator + (remainder > 0 ? "." + remainder : "") + "L";
    }
    if (val <= 999999999) {
        let numerator = parseInt(val / 10000000);
        let remainder = parseInt((val % 10000000) / 1000000, 10);
        return numerator + (remainder > 0 ? "." + remainder : "") + "Cr";
    }
}

export function secondsToDays(seconds){
    var d = Math.floor(seconds / (3600*24));
    var h = Math.floor(seconds % (3600*24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    if(d > 0 && h>0)
        return `${d}d ${h}h`;
    else if(d>0 && h <=0 )
        return `${d}d ${m}min`;
    else if(d>0 && m<=0)
        return `${d}d`;
    else if(d <= 0 && h>0)
        return `${h}h ${m}min`;
    else if(d <= 0 && h<=0)
        return `${m}min`;
}

export function getFlightDetails(type){
    if(type === "msp")
        return "Starting Flight";
    else if (type === "mfp")
        return "Final Phase";
    else
        return "";
}

export function getQualifiedMessage(pl){
    let time = "", name = "";
    if(pl.mfp_start_time && pl.mfp_name){
        let date = new Date(pl.mfp_start_time);
        time = `${date.getDate()} ${getMonth(date)} ${date.getFullYear()}, ${getTime(pl.mfp_start_time)}`;
        name = pl.mfp_name;
    }
    return `You have qualified for ${name} scheduled on ${time}. Good luck!!`;
}



export function checkLocationPermission(sendAction) {
    try {
        if(isIOS){
            if(navigator.geolocation){
                sendAction("redirectUrl");
            }
        }
        else if (detect().name !== "safari" && detect().name !== "ios") {
            navigator.permissions
            .query({ name: "geolocation" })
            .then(function (result) {
                if (result.state === "prompt") {
                sendAction("askLocation");
                } else if (result.state === "denied") {
                sendAction("locationDenialPopUp");
                } else if (result.state === "granted") {
                sendAction("redirectUrl");
                }
            });
        } else {
            sendAction("askLocation");
        }
        } catch(err) {
            console.log(err);
        }
  }
  
  export function getOrdinal(rank){
    let j = rank % 10, k = rank % 100;
    if (j == 1 && k != 11) {
        return "ST";
    }
    if (j == 2 && k != 12) {
        return "ND";
    }
    if (j == 3 && k != 13) {
        return "RD";
    }
    return "TH";
}

export function getTotalVendorMoney(balance) {
    return (balance.winning + balance.deposit + balance.bonus);
}

export function getTotalPokerMoney(balance) {
    return (balance.poker_deposit + balance.poker_bonus + balance.poker_winning);
}

export const captureExceptionAndSendToSentry = (error, err, action) => {
    Sentry.captureMessage(`Exception from ${action} Api. Here is the Error : ${err}`);
};